import {
  MENU_POST_ITEM,
  MENU_SERVICE_REQUEST_ITEM,
} from '../../../constants/menu'
import { WEBAPP_ROUTE_PREFIX } from '../../../constants/route'
import { isUnconfirmed } from '../../../utils/user'

export function getCompanyHomePageLink({ availableSections, userData }) {
  if (userData && isUnconfirmed(userData)) {
    return MENU_SERVICE_REQUEST_ITEM.to
  }

  return availableSections[MENU_POST_ITEM.uiSectionName]
    ? MENU_POST_ITEM.to
    : `/${WEBAPP_ROUTE_PREFIX}`
}
